import onload from "./utils/onload";
import {html} from "./utils/environment";

import global from "./components/global";
import carousel from "./components/carousel";
import floatingbutton from "./components/floatingbutton";
import header from "./components/header";
import submenu from "./components/submenu";
import notifybar from "./components/notifybar";

onload(() => {
    // console.log("App JS Started");

    html.classList.add("is-loaded");
    html.classList.add("is-ready");
    html.classList.remove("is-loading");

    global();
    carousel();
    notifybar();
    floatingbutton();
    header();
    submenu();
});
